import { render, staticRenderFns } from "./orderContainer.vue?vue&type=template&id=6061258c&scoped=true&"
import script from "./orderContainer.vue?vue&type=script&lang=js&"
export * from "./orderContainer.vue?vue&type=script&lang=js&"
import style0 from "./orderContainer.vue?vue&type=style&index=0&id=6061258c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061258c",
  null
  
)

export default component.exports